import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class ExamService {
  private readonly verificationKey = 'isVerified';

  constructor(private http: HttpClient) {}

  //for set candidate verification
  setVerified(status: boolean): void {
    localStorage.setItem(this.verificationKey, JSON.stringify(status));
  }

  getVerified(): boolean {
    const status = localStorage.getItem(this.verificationKey);
    return status ? JSON.parse(status) : false;
  }

  clearVerification(): void {
    localStorage.removeItem(this.verificationKey);
  }

  //exam list under a job post
  getExamPlanList(): Observable<any> {
    return this.http.get(`${environment._url}/exam/exam-plans/`);
  }
  getExamPlanJobPost(jobpostId: any): Observable<any> {
    return this.http.get(`${environment._url}/exam/exam-plans1/${jobpostId}`);
  }
  //exam details
  getExamPlanDetails(examId: any): Observable<any> {
    return this.http.get(`${environment._url}/exam/exam-plans/${examId}/`);
  }

  getExamQuestions2(categoryId: any): Observable<any> {
    return this.http.get(
      `${environment._url}/test/exam/levelsubmit/${categoryId}/`
    );
  }

  getCodingQuestion(categoryId: any): Observable<any> {
    return this.http.get(
      `${environment._url}/test/codequestions/${categoryId}/`
    );
  }

  getAllExams2(userid: any): Observable<any> {
    return this.http.get(
      `${environment._url}/test/final-submission/user/${userid}/`
    );
  }

  exam2Submit(data: any, categoryId: any): Observable<any> {
    const token = localStorage.getItem('token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` }; // Add token to headers
    return this.http.post(
      `${environment._url}/test/exam/levelsubmit/${categoryId}/`,
      data,
      { headers } // Include headers in the request
    );
  }

  exam3Submit(data: any): Observable<any> {
    const token = localStorage.getItem('token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` }; // Add token to headers
    return this.http.post(
      `${environment._url}/test/final-submission/`,
      data,
      { headers } // Include headers in the request
    );
  }

  examplans(data: any) {
    const token = localStorage.getItem('token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` }; // Add token to headers
    return this.http.post(
      `${environment._url}/test/exam-plans/`,
      data,
      { headers } // Include headers in the request
    );
  }

  examplansdelete(examId: any, data: any): Observable<any> {
    return this.http.delete(
      `${environment._url}/test/exam-plans/${examId}/`,
      data
    );
  }

  examPlanUpdate(examId: any, data: any): Observable<any> {
    return this.http.put(
      `${environment._url}/exam/exam-plans/${examId}/`,
      data
    );
  }

  //update exam
  examPlanUpdate1(data: any): Observable<any> {
    return this.http.post(`${environment._url}/exam/exam-plans/`, data);
  }

  //candidate registration for exam
  candidateExamRegistration(
    user_id: any,
    parent_exam_id: any,
    data: any
  ): Observable<any> {
    return this.http.post(
      `${environment._url}/exam/exam-registration/${user_id}/${parent_exam_id}/`,
      data
    );
  }

  //to send second mail by user id
  sendSecondMailbyUserID(user_id: any, job_post_id: any): Observable<any> {
    return this.http.get<any>(
      `${environment._url}/exam/candidate_mail2/${user_id}/${job_post_id}/`
    );
  }

  //question answer bulk upload
  questionAnswerBulkUploadL1(file: any): Observable<any> {
    return this.http.post(`${environment._url}/test/upload-question/`, file);
  }

  questionAnswerBulkUploadL2(file: any): Observable<any> {
    return this.http.post(
      `${environment._url}/test/upload-level-question/`,
      file
    );
  }
  questionAnswerBulkUploadL3(file: any): Observable<any> {
    return this.http.post(
      `${environment._url}/test/upload-code-question/`,
      file
    );
  }

  //question answer list under an exam
  getQuestionAnswerList(exam_plan_id: any): Observable<any> {
    return this.http.get(
      `${environment._url}/exam/exam_plans_question/${exam_plan_id}/questions/`
    );
  }

  //get exam list for candidate
  getExamListForCandidate(user_id: any): Observable<any> {
    return this.http.get(`${environment._url}/exam/exam-plans2/${user_id}/`);
  }

  //verification of candidates
  verifyCandidate(exam_plan_id: any, data: any): Observable<any> {
    return this.http.post(
      `${environment._url}/exam/verify_candidate/?${exam_plan_id}`,
      data
    );
  }

  //get exam list for candidate
  getMcqQuestions(exam_plan_id: any): Observable<any> {
    return this.http.get(`${environment._url}/test/questions/${exam_plan_id}/`);
  }
  getMcqQuestions1(exam_plan_id: any): Observable<any> {
    return this.http.get(`${environment._url}/exam/questions/${exam_plan_id}/`);
  }

  //get exam list for candidate
  submitAnswers(exam_plan_id: any, data: any): Observable<any> {
    return this.http.post(
      `${environment._url}/exam/conduct/${exam_plan_id}/`,
      data
    );
  }

  createset(exam_plan_id: any): Observable<any> {
    return this.http.post(
      `${environment._url}/exam/create_question_sets/${exam_plan_id}/`,
      ''
    );
  }

  //aspirant list and report
  getAspirantsData(exam_plan_id: any) {
    return this.http.get(
      `${environment._url}/exam/exam-plan/${exam_plan_id}/attached-cvs/`
    );
  }

  enableExam(registrationId: any, data: any): Observable<any> {
    return this.http.patch(
      `${environment._url}/exam/exam/exam-registration/${registrationId}/`,
      data
    );
  }

  getLevel1Questions(id: any): Observable<any> {
    return this.http.get(`${environment._url}/test/questions/${id}/choices/`);
  }
  getLevel2Questions(id: any): Observable<any> {
    return this.http.get(`${environment._url}/test/levelquestions/${id}/`);
  }
  getLevel3Questions(id: any): Observable<any> {
    return this.http.get(`${environment._url}/test/codequestions/${id}/`);
  }

  //patch and post data from post exam proccess

  postexamproccesspost(data: any): Observable<any> {
    return this.http.post(`${environment._url}/jp/post-exam-status/`, data);
  }
  postexamproccesspatch(attachId: any, data: any): Observable<any> {
    return this.http.patch(
      `${environment._url}/jp/post-exam-status/${attachId}/`,
      data
    );
  }
  getPostExamData(attachId: any) {
    return this.http.get(
      `${environment._url}/jp/post-exam-status-list/${attachId}/`
    );
  }

  getRegisteredUsers(): Observable<any> {
    return this.http.get(`${environment._url}/test/registered-users/`);
  }

  updateSelectionStatus(userId: any, statusData: any): Observable<any> {
    return this.http.patch(
      `${environment._url}/test/user/${userId}/update-selection`,
      statusData
    );
  }

  getGroupedCodeSubmissions(userId: number): Observable<any> {
    const url = `${environment._url}/test/final-submission/user/${userId}/`;
    return this.http.get<any>(url); // Returns the Observable of the API response
  }

  runcode(data: any) {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/exam/api/coding/compile/`,
      data,
      { headers } // Include headers in the request
    );
  }

  submitCode(data: any) {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/exam/api/coding/submit-code/`,
      data,
      { headers } // Include headers in the request
    );
  }

  sendInviteToEmployees(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(`${environment._url}/api/user/client/invite/`, data, {
      headers,
    });
  }

  approveEmpLoginReq(id: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/user/client/approve/${id}/`,
      null,
      { headers }
    );
  }

  getRoles() {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get<any[]>(`${environment._url}/api/user/api/roles/`, {
      headers,
    });
  }

  getPendingOrgReq() {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get<any[]>(
      `${environment._url}/api/user/pending-client-admins/
 `,
      { headers }
    );
  }

  getApprovedOrgReq() {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get<any[]>(
      `${environment._url}/api/user/approved-client-admins/
 `,
      { headers }
    );
  }

  approveEmpRegReq(id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get token
    const headers = { Authorization: `Bearer ${token}` }; // Prepare headers

    // No body is sent — just the POST request with headers
    return this.http.patch(
      `${environment._url}/api/user/approve-client-admin/${id}/`,
      data,
      { headers }
    );
  }

  

  updateUserProfile(id: any, data: any) {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/user/update-profile/${id}/`,
      data,
      { headers }
    );
  }

  toggleUserActivation(payload: {
    action: string;
    user_ids: number[];
  }): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/user/toggle-activation/`,
      payload,
      { headers }
    );
  }

  getAllJobs(): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(`${environment._url}/jobpost/post-jobs/`, { headers });
  }

  createJobs(data: any) {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/jobpost/post-jobs/`,
      data,
      { headers } // Include headers in the request
    );
  }

  jobUpdate(jobId: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/jobpost/post-jobs/${jobId}/`,
      data,
      { headers }
    );
  }

  deleteJobs(jobId: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.delete(`${environment._url}/jobpost/post-jobs/${jobId}/`, {
      headers,
    });
  }

  bulkUploadJobs(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/jobpost/jobs/bulk-upload/`,
      data,
      { headers }
    );
  }

  getCandidateRankings(jobId: number) {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get<any[]>(
      `${environment._url}/api/jobpost/candidates/rank/${jobId}/`,
      { headers }
    );
  }

  getCandidateApplicationsByJobId(jobId: number) {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    const params = { applied_job: jobId };

    return this.http.get<any[]>(
      `${environment._url}/api/candidate/candidate-applications/`,
      {
        headers,
        params,
      }
    );
  }

  getAllCandidateApplications() {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get<any[]>(
      `${environment._url}/api/candidate/candidate-applications/`,
      { headers }
    );
  }

  updateCndApps(candidate_id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/candidate/candidate_access/${candidate_id}/`,
      data,
      { headers }
    );
  }

  addComments(job_id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/jobpost/Candiate_Comments/${job_id}/`,
      data,
      { headers }
    );
  }

  sendExamInvite(job_id: any, cnd_id: any) {
    const token = localStorage.getItem('access_token'); // Get token from localStorage
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.post<any[]>(
      `${environment._url}/api/jobpost/candidates_invite/${cnd_id}/${job_id}/`,
      {},
      { headers }
    );
  }

  //create exam
  examPlanCreate(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(`${environment._url}/exam/exams/`, data, {
      headers,
    });
  }

  //get all exams
  getAllExams(): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(`${environment._url}/api/exam/exams/`, { headers });
  }

  //get round types
  getroundtypes(): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(`${environment._url}/api/exam/exam-round-types/`, {
      headers,
    });
  }

  //get questions of rounds
  getroundquestions(roundid: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(
      `${environment._url}/api/exam/question_by_round/${roundid}/`,
      { headers }
    );
  }

  //update exam
  examplansupdate(examId: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/exam/exams/${examId}/`,
      data,
      { headers }
    );
  }

  //delete rounds
  examroundsdelete(roundId: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.delete(`${environment._url}/api/exam/rounds/${roundId}/`, {
      headers,
    });
  }

  //delete exam
  examdelete(examId: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.delete(`${environment._url}/api/exam/exams/${examId}/`, {
      headers,
    });
  }

  deleteAllQuestions(data: any): Observable<any> {
    const token = localStorage.getItem('access_token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.request(
      'delete',
      `${environment._url}/api/exam/questions/delete-multiple/`,
      {
        body: data,
        headers,
      }
    );
  }

  //bulk upload round questions
  bulkUploadroundquestions(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/exam/upload_excel_files/`,
      data,
      { headers }
    );
  }

  bulkUploadCodingQuestions(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/exam/upload_coding_questions/`,
      data,
      { headers }
    );
  }

  //AI generated questions
  getaigeneratedque(
    roundid: any,
    topic: any,
    difficulty: any,
    count: any
  ): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(
      `${environment._url}/api/exam/ai-questions/?round_id=${roundid}&topic=${topic}&difficulty=${difficulty}&count=${count}`,
      { headers }
    );
  }

  //upload selected ai generated questions
  uploadAiGeneratedQues(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(`${environment._url}/api/exam/ai-questions/`, data, {
      headers,
    });
  }

  // Generate AI questions
  getAiGeneratedQuestions(jobPostId: any, numQuestions: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.get(
      `${environment._url}/api/exam/generate-questions/?job_post_id=${jobPostId}&num_questions=${numQuestions}`,
      { headers }
    );
  }

  // Upload selected AI-generated questions
  uploadAiGeneratedQuestions(data: any): Observable<any> {
    const token = localStorage.getItem('access_token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.post(
      `${environment._url}/api/exam/generate-questions/`,
      data,
      { headers }
    );
  }

  //upload questions and options manually
  uploadQueManually(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(`${environment._url}/api/exam/questions/`, data, {
      headers,
    });
  }

  //update questions and options
  questionsUpdate(queId: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/exam/questions/${queId}/`,
      data,
      { headers }
    );
  }

  //Delete questions
  questionsDelete(queId: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.delete(
      `${environment._url}/api/exam/questions/${queId}/`,
      { headers }
    );
  }

  //Get instructions
  getInstructions(exam_id: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    const url = `${environment._url}/api/exam/examdetails/${exam_id}/`;
    return this.http.get<any>(url, { headers }); // Returns the Observable of the API response
  }

  //Start Exam
  startExam(assignment_id: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(
      `${environment._url}/api/exam/start/${assignment_id}/`,
      { headers }
    );
  }

  //Get Questions
  getQuestions(assignment_id: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(
      `${environment._url}/api/exam/current-round/${assignment_id}/`,
      { headers }
    );
  }

  //Submit Rounds
  examSubmit(data: any, roundId: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/exam/submit-round/${roundId}/`,
      data,
      { headers }
    );
  }

  //Submit slots for bot round
  createSlots(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(`${environment._url}/api/exam/create_slots/`, data, {
      headers,
    });
  }

  updateSlots(slotId: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/exam/slots/${slotId}/`,
      data,
      { headers }
    );
  }

  slotDelete(slotId: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.delete(`${environment._url}/api/exam/slots/${slotId}/`, {
      headers,
    });
  }

  getAvailableSlots(round_id: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(
      `${environment._url}/api/exam/available_Slots/${round_id}/`,
      { headers }
    );
  }

  bookSlots(data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(`${environment._url}/api/exam/book_slot/`, data, {
      headers,
    });
  }

  //hiring service
  interviewandofferdetailsSubmission(cnd_id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/candidate/onboarding/info/${cnd_id}/`,
      data,
      { headers }
    );
  }

  onboardingdetailsSubmission(cnd_id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/candidate/onboarding/complete/${cnd_id}/`,
      data,
      { headers }
    );
  }

  updateOnboardingStatus(cnd_id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/candidate/candidate_access/${cnd_id}/`,
      data,
      { headers }
    );
  }

  updateJobStatus(job_id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/jobpost/jobs/change_status/${job_id}/`,
      data,
      { headers }
    );
  }

  getinterviewandofferdetailsById(cnd_id: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(
      `${environment._url}/api/candidate/onboarding/info_ge_up_del/${cnd_id}/`,
      { headers }
    );
  }

  getOnboardingdetailsById(cnd_id: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(
      `${environment._url}/api/candidate/onboarding/details_ge_up_del/${cnd_id}/`,
      { headers }
    );
  }

  updateinterviewandofferdetails(cnd_id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/candidate/onboarding/info_ge_up_del/${cnd_id}/`,
      data,
      { headers }
    );
  }

  updateOnboardingdetails(cnd_id: any, data: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.patch(
      `${environment._url}/api/candidate/onboarding/details_ge_up_del/${cnd_id}/`,
      data,
      { headers }
    );
  }

  getPendingJobPosts() {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get<any[]>(
      `${environment._url}/api/jobpost/pending-approval/`,
      { headers }
    );
  }

  approveJobPost(job_id: any, payload: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/jobpost/approve-Job/${job_id}/`,
      payload,
      { headers }
    );
  }

  rejectJobPost(job_id: any, payload: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/jobpost/reject-Job/${job_id}/`,
      payload,
      { headers }
    );
  }

  refineJobPost(payload: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/jobpost/refined_jd/`,
      payload,
      { headers }
    );
  }

  postJobFromAi(
    job_title: string,
    experience_level: string,
    required_skills: string,
    qualifications: string,
    ctc: string
  ) {
    const token = localStorage.getItem('access_token'); // Get token from localStorage
    const headers = { Authorization: `Bearer ${token}` };

    const params = new HttpParams()
      .set('job_title', job_title)
      .set('experience_level', experience_level)
      .set('required_skills', required_skills)
      .set('qualifications', qualifications)
      .set('ctc', ctc);

    return this.http.get<any>(
      `${environment._url}/api/jobpost/generate/job-details/`,
      { headers, params }
    );
  }

  getJobPostsByFilter(params: any = {}) {
    const token = localStorage.getItem('access_token');
    const headers = { Authorization: `Bearer ${token}` };

    // Build query string dynamically
    let query = new URLSearchParams();

    if (params.sort_by) {
      query.set('sort_by', params.sort_by); // newest | expiration
    }

    if (params.start_date) {
      query.set('start_date', params.start_date);
    }

    if (params.end_date) {
      query.set('end_date', params.end_date);
    }

    if (params.date_filter) {
      query.set('date_filter', params.date_filter); // e.g. 7d
    }

    return this.http.get<any[]>(
      `${environment._url}/api/jobpost/filter/jobs/?${query.toString()}`,
      { headers }
    );
  }

  // candidate.service.ts
  getCndAppByFilter(params: any = {}) {
    const token = localStorage.getItem('access_token');
    const headers = { Authorization: `Bearer ${token}` };

    // Build query string dynamically
    const query = new URLSearchParams();

    if (params.status) query.set('status', params.status);
    if (params.specific_date) query.set('specific_date', params.specific_date);
    if (params.last_7_days) query.set('last_7_days', 'true');
    if (params.month) query.set('month', params.month);
    if (params.year) query.set('year', params.year);
    if (params.day !== undefined) query.set('day', params.day.toString());
    if (params.job) query.set('job', params.job);

    return this.http.get<any[]>(
      `${
        environment._url
      }/api/candidate/filter/cand_application/?${query.toString()}`,
      { headers }
    );
  }

  sendF2fInterviewInvite(payload: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/candidate/face-to-face/interview/`,
      payload,
      { headers }
    );
  }

  getSalesCnds() {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get<any[]>(
      `${environment._url}/api/candidate/Sales_candidate-applications/`,
      { headers }
    );
  }

  sendSalesExamInvite(cnd_id: any,job_id: any): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/jobpost/sales_candidates_invite/${cnd_id}/${job_id}/`,
      {},
      { headers }
    );
  }

  assignJD(data: any,job_id: any){
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post(
      `${environment._url}/api/jobpost/assign/recruiter/${job_id}/`,
      data,
      { headers }
    );
  }

   getAssignToUsers(): Observable<any> {
    const token = localStorage.getItem('access_token'); // Get the token from localStorage
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.get(`${environment._url}/api/user/specific-user/`, {
      headers,
    });
  }



























  /* user ${environment._url} for base url */
  getEmpUsers() {
    return this.http.get(`${environment._url}/api/user/client-admin-users/`)
  }





}